module.exports = __webpack_public_path__ + "static/media/hindidiwas.35938d68.jpg";